import { render, staticRenderFns } from "./swiper_product.vue?vue&type=template&id=68d106e0&scoped=true"
import script from "./swiper_product.vue?vue&type=script&lang=js"
export * from "./swiper_product.vue?vue&type=script&lang=js"
import style0 from "./swiper_product.vue?vue&type=style&index=0&id=68d106e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d106e0",
  null
  
)

export default component.exports